module.exports = __webpack_public_path__ + "img/podium_5055.30af0082.jpg";